<template>
    <v-app-bar title="Ecvols"></v-app-bar>
</template>
<script>
export default {
    name: 'AppBar'
}
</script>